// KIRIKKALE FAR - Mock Data
// Site: https://kirikkalefar.com

export const services = [
    {
        id: 1,
        title: 'İç Dış Detaylı Far Temizliği',
        description: 'Farlarınızın iç ve dış yüzeylerini özel solüsyonlarla temizliyor, ilk günkü parlaklığına kavuşturuyoruz.',
        image: 'https://images.unsplash.com/photo-1598586958772-8bf368215c2a',
        link: '/hizmet/ic-dis-detayli-far-temizligi'
    },
    {
        id: 2,
        title: 'Stop Tamiri',
        description: 'Kırık, çatlak veya hasarlı stop lambalarınızı profesyonelce tamir ediyoruz.',
        image: 'https://images.unsplash.com/photo-1542282088-fe8426682b8f',
        link: '/hizmet/stop-tamiri'
    },
    {
        id: 3,
        title: 'Plastik Tamiri',
        description: 'Araçlarınızın plastik aksamlarındaki hasarları estetik ve dayanıklı şekilde onarıyoruz.',
        image: 'https://images.unsplash.com/photo-1601129181405-734c0d510074',
        link: '/hizmet/plastik-tamiri'
    },
    {
        id: 4,
        title: 'Far Camı Satış',
        description: 'Tüm araç modellerine uygun orijinal ve kaliteli far camları satıyoruz.',
        image: 'https://images.unsplash.com/photo-1577903514522-a78357092dac',
        link: '/hizmet/far-cami-satis'
    },
    {
        id: 5,
        title: 'Çıkma Far ve Stop',
        description: 'Uygun fiyatlı, kontrol edilmiş çıkma far ve stop seçenekleri sunuyoruz.',
        image: 'https://images.pexels.com/photos/17915248/pexels-photo-17915248.jpeg',
        link: '/hizmet/cikma-far-ve-stop'
    },
    {
        id: 6,
        title: 'Far Camı Değişimi',
        description: 'Çatlamış veya kırılmış far camlarınızı hızlıca değiştiriyoruz.',
        image: 'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800&q=80',
        link: '/hizmet/far-cami-degisimi'
    },
    {
        id: 7,
        title: 'Far Mercek Değişimi',
        description: 'Buğulanan veya ışık kaybı yaşayan far merceklerinizi değiştiriyoruz.',
        image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800&q=80',
        link: '/hizmet/far-mercek-degisimi'
    }
];

export const testimonials = [
    {
        id: 1,
        name: 'AHMET YAŞLI',
        comment: 'Far değişimi için Kırıkkale Far\'a gittim ve gerçekten profesyonel bir hizmet aldım. Farlarımın eski halinden eser yok, çok memnunum.',
        avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150'
    },
    {
        id: 2,
        name: 'AHMET FATİH',
        comment: 'Stop lambam kırılmıştı ve hemen tamir ettirdim. İşlemi çok hızlı ve kaliteli bir şekilde yaptılar. Artık stop lambam ilk günkü gibi çalışıyor.',
        avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150'
    },
    {
        id: 3,
        name: 'Mehmet Demir',
        comment: 'Kırıkkale Far sayesinde aracımın farları ilk günkü gibi oldu. İçi kararmıştı, şimdi pırıl pırıl. Tavsiye ederim!',
        avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150'
    },
    {
        id: 4,
        name: 'Ayşe Kaya',
        comment: 'Plastik tamiri için geldim, gerçekten çok iyi iş çıkardılar. Hem hızlı hem de uygun fiyatlı. Teşekkürler!',
        avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150'
    },
    {
        id: 5,
        name: 'Mustafa Öztürk',
        comment: 'Çıkma far aldım, gayet kaliteli ve temiz. Fiyatı da çok uygundu. Kesinlikle tekrar gelirim.',
        avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150'
    },
    {
        id: 6,
        name: 'Fatma Yılmaz',
        comment: 'Far mercek değişimi yaptırdım. Işık performansı çok arttı, gece sürüşleri artık çok daha güvenli.',
        avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150'
    }
];

export const contactInfo = {
    phone: '05312127605',
    phone2: '',
    email: 'kirikkalefar@gmail.com',
    address: 'Sanayi, Karadeniz Cd. 48d, 71400 KIRIKKALE / Merkez',
    city: 'Kırıkkale',
    facebook: 'https://www.facebook.com/',
    instagram: 'https://www.instagram.com/'
};

export const serviceDetails = {
    'ic-dis-detayli-far-temizligi': {
        title: 'İç Dış Detaylı Far Temizliği',
        description: 'İçi kararan, güneşten solan ve üzeri çizilmiş farlarınızı özel solüsyonlar ve profesyonel ekipmanlarla yeni gibi yapıyoruz.',
        features: [
            'Özel temizlik solüsyonları',
            'İç ve dış yüzey temizliği',
            'Parlatma ve cilalama',
            'UV koruma uygulaması',
            'Uzun ömürlü sonuç',
            'Tüm araç modellerine uygun'
        ],
        image: 'https://images.unsplash.com/photo-1598586958772-8bf368215c2a'
    },
    'stop-tamiri': {
        title: 'Stop Tamiri',
        description: 'Kırık, çatlak veya hasarlı stop lambalarınızı profesyonel ekipmanlarımızla hızlı ve kaliteli bir şekilde tamir ediyoruz.',
        features: [
            'Detaylı hasar analizi',
            'Profesyonel tamir işlemi',
            'Orijinal yedek parça',
            'Hızlı servis',
            'Kalite garantisi',
            'Uygun fiyat'
        ],
        image: 'https://images.unsplash.com/photo-1542282088-fe8426682b8f'
    },
    'plastik-tamiri': {
        title: 'Plastik Tamiri',
        description: 'Araçlarınızın plastik aksamlarındaki hasarları estetik ve dayanıklı şekilde onarıyoruz. Kırık, çatlak ve çizikler için kalıcı çözümler.',
        features: [
            'Profesyonel plastik kaynağı',
            'Estetik görünüm',
            'Dayanıklı tamir',
            'Tüm plastik parçalar',
            'Hızlı işlem',
            'Garanti belgeli'
        ],
        image: 'https://images.unsplash.com/photo-1601129181405-734c0d510074'
    },
    'far-cami-satis': {
        title: 'Far Camı Satış',
        description: 'Tüm araç modellerine uygun orijinal ve kaliteli far camları satıyoruz. BMW, Fiat, Ford, Volkswagen ve daha fazlası.',
        features: [
            'Orijinal yedek parça',
            'Tüm araç modelleri',
            'Uygun fiyat',
            'Hemen teslim',
            'Garanti belgeli',
            'Montaj hizmeti'
        ],
        image: 'https://images.unsplash.com/photo-1577903514522-a78357092dac'
    },
    'cikma-far-ve-stop': {
        title: 'Çıkma Far ve Stop',
        description: 'Uygun fiyatlı, kontrol edilmiş çıkma far ve stop seçenekleri sunuyoruz. Her marka ve model için stok mevcuttur.',
        features: [
            'Kontrol edilmiş parçalar',
            'Uygun fiyat',
            'Geniş stok',
            'Tüm marka ve modeller',
            'Garanti',
            'Değişim seçeneği'
        ],
        image: 'https://images.pexels.com/photos/17915248/pexels-photo-17915248.jpeg'
    },
    'far-cami-degisimi': {
        title: 'Far Camı Değişimi',
        description: 'Çatlamış veya kırılmış far camlarınızı hızlıca değiştiriyoruz. Tüm araç modellerine uygun orijinal ve yan sanayi seçenekleri.',
        features: [
            'Hızlı değişim',
            'Orijinal parça',
            'Profesyonel montaj',
            'Su sızıntısı önleme',
            'Garanti',
            'Tüm modeller'
        ],
        image: 'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=1200&q=80'
    },
    'far-mercek-degisimi': {
        title: 'Far Mercek Değişimi',
        description: 'Buğulanan, ışık kaybı yaşayan veya hasar görmüş far merceklerinizi profesyonelce değiştiriyoruz. Xenon, LED ve halojen farlar için özel hizmet.',
        features: [
            'Orijinal ve yan sanayi seçenekleri',
            'Işık kaybı önleme',
            'Profesyonel montaj ve kalibrasyon',
            'Test ve ayar hizmeti',
            'Su sızıntısı önleme',
            'Buğulanma garantisi'
        ],
        image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1200&q=80',
        seoTitle: 'Far Mercek Değişimi Kırıkkale | Profesyonel Mercek Tamiri',
        seoDescription: 'Kırıkkale\'de far mercek değişimi hizmeti. Buğulanan, yanan veya hasar görmüş far merceklerinin değişimi. Uygun fiyat ve kaliteli hizmet.'
    }
};

// Supported car brands
export const carBrands = [
    'BMW', 'FIAT', 'HYUNDAI', 'FORD', 'PEUGEOT', 'KIA', 
    'TOFAŞ', 'VOLKSWAGEN', 'SKODA', 'SEAT', 'OPEL', 
    'RENAULT', 'AUDI', 'HONDA', 'MAZDA', 'NISSAN', 'Motor'
];

// Company info
export const companyInfo = {
    name: 'KIRIKKALE FAR VE STOP TAMİR MERKEZİ',
    tagline: 'İçi kararan, güneşten solan ve üzeri çizilmiş otomobil, kamyonet, otobüs ve motorsiklet FAR & STOP\'larınızı yeni gibi yapıyoruz',
    experience: '4+ Yıllık Tecrübe',
    workingHours: 'Pazartesi - Cumartesi: 08:30 - 18:30',
    closedDays: 'Pazar'
};
